<script>
import Nav from "../components/pc/nav.vue";
import Bottom from "../components/pc/bottom.vue";
import Float from "../components/pc/home/float.vue";
export default {
  data() {
    return {
      bannerFixed: false,
    };
  },
  components: {
    Nav,
    Bottom,
    Float,
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 80) {
        this.bannerFixed = true;
      } else {
        this.bannerFixed = false;
      }
    },
  },
};
</script>
<template>
  <div class="home">
    <Nav :isFixed="bannerFixed" :defaultInd="4"></Nav>
    <div class="cont">
      <h5>Scam Alert</h5>
      <img src="@/assets/img/notice-sub1.png" alt="" />
      <p>
        1.Do not disclose your OTP/ PIN or password to anyone. Okash/EM will
        never request for your OTP/Pin or Password
      </p>
      <p>
        2.Do not make loan repayment into any account number, all loan repayment
        should be made on your app
      </p>
      <p>
        3.Do not respond to unknown whatsapp numbers claiming to be from
        Okash/Easemoni. Please reach out to us via our official channels: Phone
        number: Okash:02018884549/07001235051,
        Easemoni:02014111222/07001236700,or send us an email on Okash:
        <span>okash@opaymfb.com</span>,Easemoni:
        <span>easemoni@opaymfb.com.com</span>
      </p>
      <p>
        4.Do not click on any link that you are not sure about, beware of
        scammers.
      </p>
    </div>
    <Bottom class="bottom"></Bottom>
    <Float />
    <el-backtop target=".home"></el-backtop>
  </div>
</template>
<style lang="scss" scoped>
.home {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.cont {
  flex: 1;
  padding: 148px 120px 72px;
  h5 {
    color: rgba(0, 0, 0, 0.85);
    font-size: 40px;
    font-weight: 500;
    line-height: 40px;
  }
  img {
    width: 100%;
    margin: 31px 0 40px;
  }

  p {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    span {
      text-decoration-line: underline;
    }
  }
}
</style>
